module.exports = __webpack_public_path__ + "img/04.fb29db5b.jpg";